export const socials = [
  {
    key: 'twitter',
    link: 'https://t.me/devdenmak',
  },
  {
    key: 'telegram',
    link: 'https://t.me/devdenmak',
  },
  {
    key: 'linkedin',
    link: 'https://t.me/devdenmak',
  },
]
